import { render, staticRenderFns } from "./fileDetails.vue?vue&type=template&id=a17daefe&scoped=true"
import script from "./fileDetails.vue?vue&type=script&lang=js"
export * from "./fileDetails.vue?vue&type=script&lang=js"
import style0 from "./fileDetails.vue?vue&type=style&index=0&id=a17daefe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17daefe",
  null
  
)

export default component.exports